/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../../common";
import type {
  BondAuctioneer,
  BondAuctioneerInterface,
} from "../../../../contracts/test/BondAuctioneer.mock.sol/BondAuctioneer";

const _abi = [
  {
    inputs: [],
    name: "aggregator",
    outputs: [
      {
        internalType: "contract IBondAggregator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "currentCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAggregator",
    outputs: [
      {
        internalType: "contract IBondAggregator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "getConclusion",
    outputs: [
      {
        internalType: "uint48",
        name: "",
        type: "uint48",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "getMarketInfoForPurchase",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "payoutToken",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "quoteToken",
        type: "address",
      },
      {
        internalType: "uint48",
        name: "vesting",
        type: "uint48",
      },
      {
        internalType: "uint256",
        name: "maxPayout",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTeller",
    outputs: [
      {
        internalType: "contract IBondTeller",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isClosing",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isInstantSwap",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isLive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "marketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "marketScale",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
    ],
    name: "maxAmountAccepted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
    ],
    name: "payoutFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "qToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "scale",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondAggregator",
        name: "aggregator_",
        type: "address",
      },
      {
        internalType: "contract IBondTeller",
        name: "teller_",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "qTok_",
        type: "address",
      },
      {
        internalType: "contract ERC20",
        name: "pTok_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "price_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "scale_",
        type: "uint256",
      },
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "teller",
    outputs: [
      {
        internalType: "contract IBondTeller",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BondAuctioneerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BondAuctioneerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BondAuctioneer__factory extends ContractFactory {
  constructor(...args: BondAuctioneerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      BondAuctioneer & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): BondAuctioneer__factory {
    return super.connect(runner) as BondAuctioneer__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BondAuctioneerInterface {
    return new Interface(_abi) as BondAuctioneerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): BondAuctioneer {
    return new Contract(address, _abi, runner) as unknown as BondAuctioneer;
  }
}
